import { Component } from '@angular/core'

import {
  BaseDialogComponent,
  ReusableDialogComponent,
  TypographyComponent,
} from '@hyperkit'

@Component({
  selector: 'message-confirmation-dialog',
  standalone: true,
  imports: [ReusableDialogComponent, TypographyComponent],
  template: `
    <hyperkit-dialog
      class="hyperkit-component"
      [headerText]="options.headerText"
      [primaryButtonText]="options.primaryButtonText"
      (primaryAction)="return()"
    >
      <hyperkit-typography variant="body" size="sm" align="left" color="body">
        The Intel 471 Support Team will respond shortly.
      </hyperkit-typography>
    </hyperkit-dialog>
  `,
  styles: [],
})
export class MessageConfirmationDialogComponent extends BaseDialogComponent<
  boolean,
  boolean
> {
  protected initializeOptions(): void {
    this.options = {
      headerText: 'Your message has been sent!',
      primaryButtonText: 'Close',
    }
  }

  return(): void {
    this.onPrimaryAction(true)
  }
}
